import { useEffect, useRef } from 'react';

export const useKeepScrollPosition = (v: string, resetValue = '') => {
  const s = useRef<number>(0);
  useEffect(() => {
    if (v !== resetValue) s.current = window.scrollY;
    else if (s.current > 0)
      requestAnimationFrame(() => {
        window.scrollTo({
          top: s.current,
          behavior: 'instant',
        });
      });
  }, [v]);
};
